var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"art",attrs:{"dir":_vm.dir}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"art-content"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }